import {handleActions} from 'redux-actions';
import {Record} from 'immutable';

import * as ChildActions from 'web-app/react/entities/children/actions';

import * as Actions from './actions';
import * as Constants from './constants';

const About = Record({
    loading: false,
    selectedId: Constants.FORMS.BASIC_INFO,
});

export default handleActions(
    {
        [Actions.changeSelectedId.type]: (state, {payload}) =>
            state.merge({
                selectedId: payload.id,
            }),
        [ChildActions.fetchBasicChildInfo.type]: state =>
            state.merge({
                loading: true,
            }),
        [ChildActions.fetchBasicChildInfoSuccess.type]: state =>
            state.merge({
                loading: false,
            }),
        [ChildActions.fetchBasicChildInfoFailed.type]: state =>
            state.merge({
                loading: false,
            }),
    },
    new About(),
);
